import {connect} from 'react-redux';
import {ProtocolOverview as Component} from './ProtocolOverview';
import {
  showModal
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    sequence: state.notebook.protocolSection.sequence
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    }
  };
}

export const ProtocolOverview = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
